import React, { useEffect, useState } from "react"
import Col from "@bappweb/col"
import Grid from "@bappweb/grid"
import Row from "@bappweb/row"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import CalculateForm from "./calculateform"
import Campaign from "@smpu-web/nested/campaign"
import SssList from "./ssslist"
import Notes from "./notes"
import LandingHeader from "./landingheader"
import { useGetConfigMutation } from "../../../api/services"

const Landing = () => {

  const [campaigns, setCampaigns] = useState();
  const [getConfig] = useGetConfigMutation();
  useEffect(() => {
    getConfig("WebKonut.CampaignText.Landing.Top")
      .unwrap()
      .then((payload) => {
        if (!payload.IsError) {
          setCampaigns(JSON.parse(payload.configValue))
        }
      })
  }, [getConfig])

  return (
    <Block type="section" className="landing-page-wrapper" id="landing-page-wrapper">
      <LandingHeader />
      <Grid type="main" className="landing-page-main">
        <Row>
          <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
            <CalculateForm />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
            <Block className="text-section">
              <Element type="p" className="bold">
                {"Her Bütçeye Uygun Ev Kredisi Akbank’ta!"}
              </Element>
              <Element type="p" className="normal">
                {"Evinizi seçin, uygun ödeme koşullarıyla kira öder gibi ev sahibi olun!"}
              </Element>
            </Block>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
            {campaigns && <Campaign data={campaigns} />}
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
            <SssList />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
            <Notes />
          </Col>
        </Row>
      </Grid>
    </Block>
  )
}

export default Landing
